import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=3992cdaa&scoped=true"
import script from "./BillingPage.vue?vue&type=script&lang=js"
export * from "./BillingPage.vue?vue&type=script&lang=js"
import style0 from "./BillingPage.vue?vue&type=style&index=0&id=3992cdaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992cdaa",
  null
  
)

export default component.exports